import {
  CategoryListSuccess,
  CategoryAllListSuccess,
  EquipmentListSuccess,
  EquipmentAllListSuccess,
  EquipmentDetailsSuccess,
  EquipmentGetFilterSuccess,
} from '../../actionTypes/equipmentsActions';

const inititalState = {
  allCategory: [],
  categoryList: [],
  equipmentList: [],
  equipmentAllList: [],
  equipmentDetails: {},
  equipmentFilter: {},
};

export const equipmentsReducer = (state = inititalState, action) => {
  const { type, payload } = action;
  switch (type) {
    case CategoryListSuccess:
      return {
        ...state,
        categoryList: payload,
      };
    case CategoryAllListSuccess:
      return {
        ...state,
        allCategory: payload,
      };
    case EquipmentListSuccess:
      return {
        ...state,
        equipmentList: payload,
      };
    case EquipmentAllListSuccess:
      return {
        ...state,
        equipmentAllList: payload,
      };
    case EquipmentDetailsSuccess:
      return {
        ...state,
        equipmentDetails: payload,
      };
    case EquipmentGetFilterSuccess:
      return {
        ...state,
        equipmentFilter: payload,
      };
    default:
      return state;
  }
};
